export default {
  loading: "読み込み中...",
  open: "開く",
  close: "閉じる",
  stake: "賭け金",
  crdr: "W/L",
  item: "項目",
  valid: "有効",
  home_preferences: "ホーム設定",
  quick_links: "クイックリンク",
  language: "言語",
  home_page: "ホーム",
  favorites: "お気に入り",
  note: "メモ",
  my_bets: "私の賭け",
  my_account: "私のアカウント",
  contact_us: "お問い合わせ",
  report: "レポート",
  help_support: "ヘルプ ＆ サポート",
  currency: "通貨",
  others: "その他",
  welcome: "ようこそ",
  account_id: "アカウントID",
  password: "パスワード",
  account: "アカウント",
  all_sports: "すべてのスポーツ",
  my_sports: "スポーツ",
  action: "アクション",
  accept_better_odds: "より良いオッズを承認",
  accept_any_odds: "すべてのオッズを承認",
  auto_refresh_odds: "オッズを自動更新",
  auto_refresh: "自動更新",
  auto_refreshing: "自動更新中...",
  all_markets: "すべてのマーケット",
  available_balance: "利用可能残高",
  athletics: "陸上競技",
  american_football: "アメリカンフットボール",
  aussie_rules_football: "オーストラリアンフットボール",
  gmail: "Gmail",
  contact_number: "連絡先番号",

  away: "アウェイ",

  all: "すべて",
  accepted: "承認済み",
  add: "追加",
  add_homescreen: "ホーム画面に追加",
  abandoned: "放棄",

  bet_slip: "ベットスリップ",
  bet_credit: "ベットクレジット",
  bet_list: "ベットリスト",
  betting: "賭け",
  balance: "残高",

  betting_statement: "ベット明細書",
  betting_rules: "ベッティングルール",
  bet_types: "ベットタイプ",
  bs: "B/S",
  bet_summary: "ベット概要",
  bets: "賭け",
  basketball: "バスケットボール",
  baseball: "野球",
  badminton: "バドミントン",
  bandy: "バンディ",
  boxing: "ボクシング",
  beach_soccer: "ビーチサッカー",
  back: "戻る",

  casino: "カジノ",
  cash_balance: "現金残高",
  change_account_password: "アカウントパスワードを変更",
  current_password: "現在のパスワード",
  confirm_new_password: "新しいパスワードを確認",
  customize_sports_order: "スポーツ順序をカスタマイズ",
  choice: "選択",
  credit: "クレジット",
  commission: "手数料",
  customize: "カスタマイズ",
  cancel: "キャンセル",
  confirmation: "確認",
  continue_bet: "賭けを続ける",
  customer_service: "カスタマーサービス",
  cricket: "クリケット",
  cycling: "サイクリング",
  copa_america: "コパアメリカ",
  combinations: "組み合わせ",
  create_room: "プライベートルームを作成",

  darts: "ダーツ",
  debit: "デビット",
  display_language: "表示言語",
  default_event_sorting: "デフォルトイベントソート",
  default_stake: "デフォルトの賭け金",
  date: "日付",
  draw: "引き分け",
  draw_cancel: "引き分け",
  dec: "DEC",
  double_line: "ダブルライン",
  disable: "無効にする",
  dec_odds: "DEC | デシマルオッズ",
  id_odds: "IND | インドオッズ",
  double_chance: "ダブルチャンス",
  details: "詳細",

  enable: "有効にする",
  event_sorting: "イベントソート",
  e_sports: "Eスポーツ",
  esports2: "Eスポーツ 2",
  edit: "編集",
  early: "早期",
  event: "イベント",
  even: "偶数",
  email: "メール",
  esports: "Eスポーツ",
  entry_fee: "参加費",
  exclusive: "排他的",
  event_worldcup: "ワールドカップ",
  event_euro: "EURO 2024",
  event_copa: "COPA 2024",
  event_olympic: "オリンピック 2024",

  es_101: "マップ 1",
  es_102: "マップ 2",
  es_103: "マップ 3",
  es_104: "マップ 4",
  es_105: "マップ 5",
  es_106: "マップ 6",
  es_107: "マップ 7",
  es_108: "マップ 8",
  es_109: "マップ 9",
  es_110: "マップ 10",

  fd_101: "1ST 賞",
  fd_102: "2ND 賞",
  fd_103: "3RD 賞",

  first_goal: "先制ゴール",
  first_half: "前半",
  final: "決勝",
  full_time: "フルタイム",
  from: "から",
  field_hockey: "フィールドホッケー",
  futsal: "フットサル",
  fd: "4D スペシャル",
  fishing: "釣り",
  fold: "折り",

  gaelic_football: "ゲーリックフットボール",
  golf: "ゴルフ",
  games: "ゲーム",
  given_credit: "与えられたクレジット",
  group: "グループ",
  goal: "ゴール",
  general: "一般",
  general_betting_rules: "一般的な賭けルール",
  general_rules_market: "一般ルール: マーケット (ベットタイプ)",

  half_time: "ハーフタイム",
  hide_header: "ヘッダーを非表示",
  hk: "HK",
  hk_odds: "HK | 香港オッズ",
  hdp: "ハンディキャップ",
  home: "ホーム",
  hotline: "ホットライン",
  handball: "ハンドボール",
  hurling: "ハーリング",
  hour: "時間",
  highlight: "ハイライト",

  id: "ID",
  ice_hockey: "アイスホッケー",

  joined: "参加のみ",
  join_now: "今すぐ参加",
  jackpot: "ジャックポット",

  keno: "ケノ",
  kickoff: "キックオフ",
  kabbadi: "カバディ",
  kof: "キングオブファイターズ",
  ko: "K.Oにより",
  
  lose: "負け",
  lose_half: "半分負け",
  lottery: "宝くじ",
  login: "ログイン",
  logout: "ログアウト",
  last_login: "最終ログイン",
  last_transaction: "最終取引",
  live_streaming: "ライブ配信",
  live_match: "ライブマッチ",
  live_chat: "ライブチャット",
  live: "ライブ",
  live_tv: "ライブTV",
  livecasino: "ライブカジノ",
  loss: "損失",
  lost: "失われた",
  last_bet: "最後のベット",
  last_goal: "最後のゴール",
  leave_room: "ルームを離れる",
  last_betting_time: "最終賭け時間",
  lose_all: "全損",

  mobile: "モバイル",
  message: "メッセージ",
  my_bet: "私のウォレット",
  my_favorites: "私のお気に入り",
  market_type: "マーケットタイプ",
  match: "試合",
  message_history: "メッセージ履歴",
  my: "MY",
  market: "マーケット",
  main_markets: "メインマーケット",
  my_odds: "MY | マレーオッズ",
  mmo_parlay: "ミャンマーパーレイ",
  mmo_odds: "ミャンマーオッズ",
  min: "最小",
  max: "最大",
  max_payout: "最大支払額",
  main: "メイン",
  corners: "コーナー/ブッキング",
  specials: "スペシャル",
  mix_parlay: "ミックスパーレイ",
  mma: "総合格闘技 (MMA)",
  motorsports: "モータースポーツ",
  muay_thai: "ムエタイ",
  map1: "マップ  1",
  map2: "マップ  2",
  map3: "マップ  3",
  map4: "マップ  4",
  map5: "マップ  5",
  map6: "マップ  6",
  map7: "マップ  7",
  map8: "マップ  8",
  map9: "マップ  9",
  matches: "試合",
  mini_arcade: "ミニアーケード",
  match_started: "開始済み",

  no_goal: "ゴールなし",
  normal_announcements: "通常のお知らせ",
  nickname: "ニックネーム",
  new_password: "新しいパスワード",
  new: "新しい",
  "no/": "No.",
  normal_sorting: "通常の並べ替え",
  netball: "ネットボール",
  newsinfo: "ニュース＆情報",
  next: "次",

  olympic: "オリンピック",
  other_markets: "他のマーケット",
  outstanding: "未解決",
  odds_type: "オッズタイプ",
  odds: "オッズ",
  opening_balance: "開始残高",
  outright: "アウトライト",
  oe: "O/E",
  on: "オン",
  off: "オフ",
  outstanding_bet: "未決済の賭け",
  over: "オーバー",
  odd: "奇数",
  official_link: "公式リンク",
  owner: "所有者",

  password_expiry: "パスワードの有効期限",
  parlay: "パーレイ",
  parlay_early: "早期パーレイ",
  page_display: "ページ表示",
  page_type: "ページタイプ",
  page_size: "ページサイズ",
  personal_message: "個人メッセージ",
  process_bet: "賭けを置く",
  payout: "払い戻し",
  pending: "保留中",
  personal: "個人",
  play_now: "今すぐプレイ",
  parlay_generator: "パーレイジェネレーター",
  private: "プライベート",
  pool: "支払い $",
  players: "プレイヤー",
  points: "ポイント",
  prize: "賞金",
  play_to_earn: "プレイして稼ぐ",

  quick_bet: "クイックベット",
  qq: "QQ",

  room: "ルーム",
  result: "結果",
  restore: "復元",
  remark: "備考",
  ref_no: "参照番号",
  remove_from_parlay: "パーレイから削除",
  running: "実行中",
  reject: "拒否",
  rejected: "拒否されました",
  rugby: "ラグビー",
  roundof16: "ラウンド16",
  quater_finals: "準々決勝",
  semi_finals: "準決勝",
  room_id: "ルームID",
  refund: "返金",

  skype: "Skype",
  sports: "スポーツ",
  show_balance: "残高を表示",
  statement: "ステートメント",
  settings: "設定",
  search_team: "チーム検索",
  show_header: "ヘッダーを表示",
  submit: "提出",
  set_nickname: "ニックネームを設定",
  single: "シングル",
  save: "保存",
  show_score_map: "スコアマップを表示",
  status: "ステータス",
  sort: "並べ替え",
  sportsbook: "スポーツブック",
  sum: "合計",
  special_announcements: "特別なお知らせ",
  subtotal: "小計",
  single_line: "シングルライン",
  sort_by_time: "時間順に並べ替え",
  slots: "スロット",
  select_leagues: "リーグを選択",
  special: "スペシャル",
  scroll_bottom: "ベッティングエリアまでスクロール",
  swipe_to_search: "スワイプして検索",
  soccer: "サッカー",
  squash: "スカッシュ",
  sepak_takraw: "セパタクロー",
  snooker: "スヌーカー/プール",
  suite_sa: "SA Gaming",
  suite_gp: "Game Play",
  suite_evo: "Evolution",
  suite_ct855: "CT855",
  suite_bg: "Macau Suite",
  suite_pg: "Pretty Gaming",
  suite_yb: "Yeebet",
  "suite_pp-c": "Pragmatic",
  suite_ai: "AI Casino",
  sfv_101: "ラウンド  1",
  sfv_102: "ラウンド  2",
  sfv_103: "ラウンド  3",
  sfv_104: "ラウンド  4",
  sfv_105: "ラウンド  5",
  settlement: "決済",
  settled_amount: "決済金額",
  sfv: "Street Figther V",
  search: "検索",
  sysparlay: "システムパーレイ",
  stake_per_bet: "ベットごとの賭け金",
  score: "スコア",
  winner: "勝者",
  slot_live22: "Live22",
  slot_pgs: "PGSoft",
  slot_ppg: "Pramagtic Play",
  slot_jkr: "Joker",
  slot_spp: "Simple Play",
  slot_jili: "Jili",
  slot_uusl: "UUSlot",
  slot_next: "Nextspin",
  slot_dbhash: "DB Hash",
  slot_wow: "WOW Gaming",
  slot_wf: "WF Gaming",
  selected: "選択済み",
  select_matches: "試合を選択",

  turnover: "売上高",
  today: "今日",
  time: "時間",
  team: "チーム",
  to: "へ",
  trans_time: "取引時間",
  total: "合計",
  total_goal: "合計ゴール",
  treble: "トレブル",
  total_bets: "合計ベット",
  tnc: "一般利用規約",
  tennis: "テニス",
  table_tennis: "卓球",
  telegram: "Telegram",
  tournament: "トーナメント",
  total_points: "合計ポイント",
  tournament_refund: "トーナメント返金",

  under: "アンダー",
  void: "無効",
  volleyball: "バレーボール",
  void_list: "無効リスト",
  view_odds: "オッズを表示",
  video: "ビデオ",

  won_all: "全勝",
  won_half: "半勝",
  win_half: "半勝",
  win: "勝利",
  won: "勝ち",
  waiting: "待機中",
  wechat: "Wechat",
  whatsapp: "Whatsapp",
  winter_sports: "冬のスポーツ",
  water_polo: "水球",
  winner_rank: "勝者ランク",

  yes: "はい",
  no: "いいえ",

  yesterday: "昨日",
  monday: "月曜日",
  tuesday: "火曜日",
  wednesday: "水曜日",
  thursday: "木曜日",
  friday: "金曜日",
  saturday: "土曜日",
  sunday: "日曜日",

  all_league: "全て",
  match_completed: "完了",
  match_pending: "結果待ち",
  match_cancelled: "返金",
  match_cancelled_1h: "返金1H",
  match_cancelled_2h: "返金2H",
  match_suspended: "中止",
  match_suspended_1h: "中止1H",
  match_suspended_2h: "中止2H",

  check_all: "全て選択",
  selected_only: "選択のみ",
  filtered: "フィルタリング済み",
  turn_on: "オン",
  turn_off: "オフ",

  more_bet_types: "他の賭け種類",
  switch_to_desktop: "デスクトップに切り替え",

  events: "イベント",
  brackets: "ブラケット",
  standing: "スタンディング",

  big_small: "大/小",
  odd_even: "奇数/偶数",

  first_digit: "1桁目",
  second_digit: "2桁目",
  third_digit: "3桁目",
  forth_digit: "4桁目",
  total_4d: "合計4D",
  total_3d: "最後の3D合計",
  total_1st2d: "最初の2D合計",
  total_last2d: "最後の2D合計",
  total_winlose: "合計勝敗",
  tomorrow: "明日",

  news: "ニュース",
  more: "もっと",
  current_live: "現在のライブ",
  upcoming: "近日開催",
  prematch: "プレマッチ",
  desktop_view: "デスクトップ表示",
  back_to_lobby: "ロビーに戻る",
  coming_soon: "近日公開",
  no_record: "記録が見つかりません",
  bet_time: "ベット時間",
  seven_days: "過去7日間",
  fourteen_days: "過去14日間",
  winlose: "勝敗",
  all_transaction: "すべての取引",
  transfer: "転送",
  hide: "非表示",
  more_details: "詳細をもっと見る",
  bet: "ベット",
  comm: "手数料",
  settled: "決済済み",
  total_stake: "合計賭け金",
  deselect_all: "すべての選択を解除",
  select_all: "すべて選択",
  done: "完了",
  early_all: "早期 (すべて)",
  more_markets: "その他のマーケット",
  folds_2: "2 フォールド",
  folds_3: "3 フォールド",
  folds_4: "4 フォールド",
  folds_5: "5 フォールド",
  folds_6: "6 フォールド",
  folds_7: "7 フォールド",
  folds_8: "8 フォールド",
  folds_9: "9 フォールド",
  folds_10: "10 フォールド",
  folds_11: "11 フォールド",
  folds_12: "12 フォールド",
  go_today_matches: "今日の試合へ",
  go_live_matches: "ライブ試合へ",
  remember_stake: "賭け金を覚える",
  confirm: "確認",
  parlay_slip: "パーレイスリップ",
  parlay_slip_selection: "パーレイスリップ - 選択",
  remove_all: "すべて削除",
  add_more_selection: "さらに選択を追加",
  retain_selections: "選択を保持",
  settled_remark: "注意: 今日のマーケットの賭けが表示され、決済済みの試合のチケットはステートメントに移動されます。",
  w4d: "4D",
  tutorial_tooltips: "このアプリをホーム画面にインストールする方法",
  tutorial: "チュートリアル",
  dismiss: "閉じる",
  euroDate: "12 JUNE - 12 JULY",
  goto_statement: "ステートメントへ",
  no_bet: "ベットなし",

  random_pick: "ランダム選択",
  add_pick: "ベットスリップに追加",

  worldcup: "ワールドカップ 2022",
  time_remaining: "残り時間",

  slot_championstar: "チャンピオンスター",
  slot_fifafiesta: "フィファフィエスタ",
  slot_penaltymania: "ペナルティマニア",
  minigame_dragon: "ドラゴンの宝物",
  minigame_illuvium: "イリュビウムマスター",
  minigame_mobo: "Moboxオリンピア",

  egames: "V-ゲーム",
  feedback: "ユーザーエクスペリエンスフィードバック",
  ranking: "ランキング",
  total_winning: "合計勝利",
  first_prize: "1位賞品",
  second_prize: "2位賞品",
  third_prize: "3位賞品",
  place: "場所",
  current_point: "現在のポイント",
  free_room: "無料ルーム",
  last_join_time: "最終参加時間e",
  archery: "アーチェリー",
  ufc: "UFC",
  winter_olympic: "冬季オリンピック",
  no1: "1位",
  adjustment: "調整",
  poker: "ポーカー",
  poker_db: "DBポーカー"
};
